module.exports = __webpack_public_path__ + "static/img/swiper_down.1fa7e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper_down.png
// module id = UNEp
// module chunks = 0